import { trackError, track, setLock, releaseLock, isLocked } from '../helpers';
import { types } from './types';
import { createFetchExperiment, skipExperiment } from './actions';
export const createMiddleware = (params) => {
    const { endpoint = null, initialExperiments, onExperimentLoad = null, logger = console, trackError: trackOnError = trackError, track: trackOnSuccess = track, } = params;
    if (!endpoint) {
        logger.error('Missing endpoint argument.');
        return null;
    }
    if (typeof onExperimentLoad === 'function' && initialExperiments) {
        Object.keys(initialExperiments).forEach(projectId => onExperimentLoad(initialExperiments[projectId]));
    }
    return ({ dispatch }) => next => action => {
        try {
            const { type, payload = {} } = action;
            if (type === types.FETCH_EXPERIMENT.ERROR) {
                releaseLock(payload.projectId);
                trackOnError(payload);
            }
            else if (type === types.FETCH_EXPERIMENT.SUCCESS) {
                releaseLock(payload.projectId);
                if (typeof onExperimentLoad === 'function') {
                    onExperimentLoad(payload);
                }
                trackOnSuccess(payload);
            }
            else if (type === types.REQUEST_EXPERIMENT) {
                const nextResult = next(action);
                const { projectId } = payload;
                if (!isLocked(projectId)) {
                    setLock(projectId);
                    dispatch(createFetchExperiment(endpoint)(projectId));
                }
                else {
                    dispatch(skipExperiment(projectId));
                }
                return nextResult;
            }
        }
        catch (e) {
            logger.error(e);
        }
        return next(action);
    };
};
//# sourceMappingURL=middleware.js.map